import React from 'react';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import { postData } from '../../functions/postData.js';
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Icon from '@mdi/react';
import { mdiAccountMultiple  } from '@mdi/js';
import { _ } from '../../functions/translator.js';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core'
import { deleteCardsFromCardsGroups } from '../../actions/index.js';


function AssignButton(props){
    const { selectedCardsGroups, projectUsers} = useSelector(state => ({
        selectedCardsGroups: state.selectedCardsGroups,
        projectUsers: state.projectUsers
    }))
    const [show, setShow] = useState(false);
    const [showAssign, setShowAssing] = useState(false);
    const [showUnassign, setShowUnassign] = useState(false);
    const [showSuccesAssignToast, setShowSuccessAssignToast] = useState(false);
    const [showSuccesUnassignToast, setShowSuccessUnassignToast] = useState(false);
    const [showFailureToast, setShowFailureToast] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleAssignClose = () => {
        setShowAssing(false)
        setShow(true)
    }
    const handleAssignShow = () => {
        setShow(false)
        setShowAssing(true)
    }

    const handleUnassignClose = () => {
        setShowUnassign(false)
        setShow(true)
    }
    const handleUnassignShow = () => {
        setShow(false)
        setShowUnassign(true)
    }

    const handleChange = (event) => {
        setSelectedUsers(event.target.value);
    };

    const handleSubmit = async() => {
        setShowLoading(true)
        try {
            
            const idsUsers = selectedUsers.map(user => user.id);
            const urlPost = {
                cards_group_ids: selectedCardsGroups,
                type: showAssign? "assign": "unassign",
                users_ids: idsUsers
            };
            
            const response = await postData('/assign-users-in-charge', urlPost, 'Error en la solicitud');
            props.deleteCardsFromCardsGroups(selectedCardsGroups)
            
            if (response.status === 200) {
                if(showAssign){
                    setShowAssing(false)
                    setShowSuccessAssignToast(true);
                    setShow(true)
                } else {
                    setShowUnassign(false)
                    setShowSuccessUnassignToast(true)
                    setShow(true)
                }
            } else {
                setShowAssing(false)
                showUnassign(false)
                setShowFailureToast(true);
            }

        } catch (error) {
            console.error('Error:', error);
            setShowFailureToast(true);
        } finally {
            setShowLoading(false)
        }
    }

    const useStyles = makeStyles((theme) => ({
        selected: {
          backgroundColor: '#3f51b5 !important',
          color: 'white',
        },
      }));
    const classes = useStyles();

    return(
        <>
            {props.popUpMenu===true?
            <div className='w-100' onClick={handleShow}>
                <div className='d-inline-flex'>
                    <div className='d-flex align-items-center'>
                        <Icon path={ mdiAccountMultiple } size='30px' color='white' style={{margin: 10}}/>
                    </div>
                    <p>{ _('Encargados') }</p>
                </div>
            </div>
            :<Button 
                onClick={handleShow} 
                size='small' 
                style={{width:'100%', background:'#ff5300', color:"#ffffff", textTransform: 'none', fontWeight:700}}>
                <div className='d-flex flex-row'>
                    <Icon path={mdiAccountMultiple} size={1} />
                    <p style={{fontFamily:'Rubik', margin:'0px'}}>{ _('Encargados') }</p>
                </div>
            </Button>}
            
            <Snackbar 
                className='w-100 p-0' 
                onClose={() => setShowSuccessAssignToast(false)} 
                open={showSuccesAssignToast} 
                autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="success">
                    <p className='text-center w-100 m-0'>
                        {`¡Se han asignado los encargados seleccionados a ${selectedCardsGroups.length} 
                        ${selectedCardsGroups.length == 1?'registro':'registros'} exitosamente!`}
                    </p>
                </MuiAlert>
            </Snackbar>
            <Snackbar 
                className='w-100 p-0' 
                onClose={() => setShowFailureToast(false)} 
                open={showFailureToast} 
                autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="error">
                    <p className='text-center w-100 m-0'>¡{_('Ha ocurrido un error al asignar/desasignar encargados')}!</p>
                </MuiAlert>
            </Snackbar>
            <Snackbar 
                className='w-100 p-0' 
                onClose={() => setShowSuccessUnassignToast(false)} 
                open={showSuccesUnassignToast} 
                autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="success">
                    <p className='text-center w-100 m-0'>
                        {`¡Se han desasignado encargados a ${selectedCardsGroups.length} registros exitosamente!`}
                    </p>
                </MuiAlert>
            </Snackbar>
            <Modal show={show} onHide={handleClose} className="fade" style={{fontFamily:"Rubik"}}>
                <Modal.Header>
                    <p style={{fontFamily:'Rubik' , margin:'0px', }}>{_('Asignar/Desasignar Encargados')}</p>
                    <div className='close-button text-md' onClick={handleClose}>
                        x
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <p>{_('Asignarás o desasignarás encargados a los registros seleccionados')}</p>
                    <Form method="POST" >
                        <p>{_('Registros seleccionados')}: {selectedCardsGroups.length}</p>
    
                        <Form.Group className='mt-2' controlId="input_type">
                            <div className='ml-1'><Form.Label>{_('Seleccionar Usuarios')}:</Form.Label></div>
                            <div style={{position: 'relative'}}>
                                <Select
                                    name="input_type"
                                    required
                                    multiple
                                    value={selectedUsers}
                                    onChange={handleChange}
                                    MenuProps={{
                                        MenuListProps: {
                                            disablePadding: true,
                                        },
                                        classes: {
                                            paper: classes.paper,
                                        },
                                        PaperProps: {
                                            style: {
                                              maxHeight: 300,
                                              top: '0px',
                                              position: 'fixed',
                                            },
                                        },
                                        getContentAnchorEl: null,
                                    }}
                                    renderValue={(selected) => selected.map(selected => 
                                        {return `${selected.attributes.first_name} ${selected.attributes.last_name} ${selected.attributes.position && `- ${selected.attributes.position}`}`}).join(', ')
                                    }
                                    >
                                    {Object.values(projectUsers).map((user) => (
                                        <MenuItem key={user.attributes.id} value={user} classes={{
                                            selected: classes.selected,
                                        }}>
                                        {user.attributes.first_name} {user.attributes.last_name} {user.attributes.position && `- ${user.attributes.position}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        </Form.Group>
                        
                        <div className='d-flex justify-content-center mt-3 mb-1'>
                            <div style={{ position: 'relative' }}>
                                <Button 
                                    onClick={handleAssignShow} 
                                    disabled={selectedUsers.length === 0} 
                                    variant="contained" 
                                    className="success-button mr-2" 
                                    style={{textTransform: 'none', paddingLeft: '5px', paddingRight: '5px'}}>
                                    <p className='w-100' style={{fontFamily:"Rubik", margin:'0px'}}>{_('Asignar Encargados')}</p>
                                </Button>
                                <Button 
                                    onClick={handleUnassignShow} 
                                    disabled={selectedUsers.length === 0} 
                                    variant="contained" 
                                    className='confirm-delete-button-assign' 
                                    style={{textTransform: 'none', paddingLeft: '5px', paddingRight: '5px'}}>
                                    <p className='w-100' style={{fontFamily:"Rubik", margin:'0px'}}>{_('Desasignar Encargados')}</p>
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={showAssign} onHide={handleAssignClose} className="fade" style={{fontFamily:"Rubik"}}>
                <Modal.Body>
                    <p>{`¿${_('Desea asignar los usuarios seleccionados a')} ${selectedCardsGroups.length} 
                        ${selectedCardsGroups.length == 1?_('registro'):_('registros')}?`}
                    </p>
                    <div className='d-flex justify-content-center mt-3 mb-1'>
                        <div style={{ position: 'relative' }}>
                            <Button 
                                onClick={handleSubmit} 
                                variant="contained" 
                                className="success-button" 
                                style={{textTransform: 'none', paddingLeft: '5px', paddingRight: '5px'}}>
                                    <p style={{fontFamily:"Rubik", margin:'0px'}}>{_('Asignar Encargados')}</p>
                            </Button>
                            {showLoading && 
                                <div style={{ position: 'absolute', top: '20%', right: '-25px' }}>
                                    <CircularProgress style={{ width:'20px', height:'20px' }} />
                                </div>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showUnassign} onHide={handleUnassignClose} className="fade" style={{fontFamily:"Rubik"}}>
                <Modal.Body>
                    <p>{`¿${_('Desea asignar los usuarios seleccionados a')} ${selectedCardsGroups.length} 
                        ${selectedCardsGroups.length == 1?_('registro'):_('registros')}?`}
                    </p>
                    <div className='d-flex justify-content-center mt-3 mb-1'>
                        <div style={{ position: 'relative' }}>
                            <Button 
                                onClick={handleSubmit} 
                                variant="contained" 
                                className='confirm-delete-button' 
                                style={{textTransform: 'none', paddingLeft: '5px', paddingRight: '5px'}}>
                                    <p style={{fontFamily:"Rubik", margin:'0px'}}>{_('Desasignar Encargados')}</p>
                            </Button>
                            {showLoading && 
                                <div 
                                    style={{ position: 'absolute', top: '20%', right: '-25px' }}>
                                    <CircularProgress style={{ width:'20px', height:'20px' }} />
                                </div>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}


const mapDispatchToProps = {
    deleteCardsFromCardsGroups : deleteCardsFromCardsGroups
};

export default connect(null, mapDispatchToProps)(AssignButton);